import type { SangjoReviewTag } from "@/types/reviewType";

export const SANGJO_REVIEW_TAGS: SangjoReviewTag[] = ["장례지도사", "상담", "상황", "정책"];

export const SANGJO_REVIEW_DETAIL_TEXT = {
  장례지도사: "믿고 맡길 수 있는 장례지도사",
  상담: "친절하고 자세한 상담",
  상황: "막막한 상황",
  정책: "합리적이고 투명한 정책",
} as {
  [key: string]: string;
};

export const SANGJO_REVIEW_SUB_TEXT = {
  장례지도사: " 를 경험하신 후기",
  상담: " 부터 함께 하신 고객님들의 후기",
  상황: " 도움을 받으신 고객님들의 후기",
  정책: " 에 만족하신 고객님들의 후기",
} as {
  [key: string]: string;
};
